import PopupActions from '../../../actions/PopupActions';

import PosCartStore from '../../../stores/PosCartStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import UserStore from '../../../stores/UserStore';
import SpringBigOffer from './SpringBigOffer.react';
import SpringBigReward from './SpringBigReward.react';
import NotificationActions from '../../../actions/NotificationActions';
import SpringBigAppliedReward from './SpringBigAppliedReward';
import { endPoints as SpringBigEndpoints } from '../../../constants/SpringBigConstants';

class SpringBigRedeem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            offers: [],
            rewards: [],
            member: null,
            pointsSpent: 0,
            appliedRewards: [],
            loading: false
        };

        this.onClose = this.onClose.bind(this);
        this.refreshRewards = this.refreshRewards.bind(this);
    }

    componentDidMount() {
       this.refreshRewards();
    }

    refreshRewards() {
        this.setState({ loading: true });
        AjaxPromises.POST(SpringBigEndpoints.GET_OFFERS_REWARDS, UserStore.getApiData({ 
            AcctId: this.props.guest.Guest_id,
            ShipmentId : this.props.guest.ShipmentId,
        })).then((resp) => {
            if(!resp.Result) {
                NotificationActions.error(`Error loading rewards and offers: ${resp.Message}`);
                return;
            } else {
                this.setState({
                    offers: resp.Data.offers,
                    rewards: resp.Data.rewards, 
                    member: resp.Data.member,
                    pointsSpent: resp.Data.pointsSpent || 0,
                    appliedRewards: resp.Data.appliedRewards
                });
            }
            this.setState({ loading: false });  
        });
       
    }

    onClose() {
        PopupActions.close();
    }
    

    render() {
        return (
            <div className='popup__content redeem'>

                <div className='popup-header'>
                    REDEEM SPRING BIG OFFERS AND REWARDS

                    <div
                        className='popup-close'
                        onClick={() => { PopupActions.close(); }}>

                        <i className='fa fa-times' aria-hidden='true' />
                    </div>
                </div>
                

                {this.state.loading && <i className="fa fa-spinner fa-pulse fa-5x" style={{ position: 'absolute', left:'50%', top: '50%' }} aria-hidden="true" /> }
                { !this.state.loading  &&
                <div className='SpringBigRedeemContent'>
                    <div className='row SpringBigOfferInfo'>
                        <div className='col-md-6'>
                            <div className='reward-offer-container'>
                                <h2 className='springbig-header'>Balance Info</h2>
                                <div className='springbig-balance-info'>
                                    <div><span className='springbig-text'>Available Points:</span> {this.state.member ? this.state.member.balance : 0}</div>
                                    <div><span className='springbig-text'>Points Redeemed:</span> {this.state.pointsSpent}</div>
                                    <div><span className='springbig-text'>Points Remaining:</span> {(this.state.member ? this.state.member.balance : 0) - this.state.pointsSpent}</div>
                                </div>
                            </div>
                        </div>
                        
                        
                        <div className='col-md-6'>
                            <div className='reward-offer-container'>
                                <h2 className='springbig-header'>Redeemed Rewards and Offers</h2>
                                <div className='RedeemedRewards'>
                                    {
                                        !!this.state.appliedRewards && this.state.appliedRewards.map(x => {
                                            return <SpringBigAppliedReward 
                                                reward={x}
                                                guest={this.props.guest}
                                                onRemove={this.refreshRewards}
                                            />
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    

                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='reward-offer-container'>
                                <h2 className='springbig-header'>Offers</h2>
                                <div className='springbig-card-list'>
                                {this.state.offers.map(x => <SpringBigOffer 
                                    offer={x}
                                    cart={this.props.cart}
                                    guest={this.props.guest}
                                    onClose={this.onClose}
                                />)}
                                </div>
                            </div>
                        </div>
                        
                        <div className='col-md-6'>
                            <div className='reward-offer-container'>
                                <h2 className='springbig-header'>Rewards</h2>
                                <div className='springbig-card-list'>
                                {this.state.rewards.map(x => <SpringBigReward 
                                        reward={x}
                                        cart={this.props.cart}
                                        guest={this.props.guest}
                                        balance={(this.state.member ? this.state.member.balance : 0)}
                                        spentPoints={this.state.pointsSpent}
                                        onClose={this.onClose}
                                    />)}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                }
            </div>
        );
    }
}

export default SpringBigRedeem;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/springbig-redeem/SpringBigRedeem.react.jsx